/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Completed_HintInputs */



/**
* | output |
* | --- |
* | "Has played all their rounds. Can still make the finals." |
*
* @param {Player_Completed_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const player_completed_hint = /** @type {((inputs?: Player_Completed_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Completed_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("A joué toutes ses rondes. Peut encore aller en finale.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ha jugado todas sus rondas. Aún puede llegar a la final.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Jogou todas as suas rodadas. Ainda pode ir para a final.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ha giocato tutti i suoi round. Può ancora arrivare in finale.")
	return /** @type {LocalizedString} */ ("Has played all their rounds. Can still make the finals.")
});